import { useState } from "react";

const QA = [
  {
    q: "黑料色动图跟普通的图站有什么区别？",
    a: "这里的动图更偏「高能名场面」：把最炸的情绪瞬间抽成循环，按场景与情绪词库切好，找起来比在一个词上反复刷快得多。",
  },
  {
    q: "短视频、录屏和片段剪辑要怎么区分？",
    a: "短视频是重新卡过节奏的剪辑，录屏则保留原汁原味的回放，片段通常指单段高光。三种都会标在卡片左上角，看的时候不会混。",
  },
  {
    q: "想找某类黑料色录屏，从哪下手最快？",
    a: "建议先切到「按场景切片」，选直播回放或翻车记录这类词条；也可以直接参考今日热榜，把当天最热的那批先过一遍。",
  },
  {
    q: "表情包要拿去回消息，能直接找到现成的吗？",
    a: "可以。表情包按情绪词库分好，高光台词、神回复都被压成了单张图，点开就能存，适合直接甩进聊天用。",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="relative w-full bg-background-100/70">
      <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <p className="flex items-center justify-center gap-2 text-xs font-medium tracking-widest text-primary-700">
            <i className="ri-question-line" />
            FAQ
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            关于黑料色的几个常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-7 text-foreground-600">
            第一次来不知道怎么找动图、录屏还是表情包？看这里就能理顺。
          </p>
        </div>

        <div className="mt-9 flex flex-col gap-3">
          {QA.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-xl border bg-background-50 transition ${
                  isOpen ? "border-primary-200" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-add-line transition ${isOpen ? "rotate-45" : ""}`} />
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4 md:px-6">
                    <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}